export default __webpack_public_path__ + "static/media/Picture-African-business1.7d1bfb4e.png";